export default "__VITE_ASSET__DG6zhHf0__"